import { useMemo } from 'react';

import { useBreadcrumbItems } from '@kc-console/shared-ui';

import { ROUTE_PATH } from '../config/routes';
import { useRegionEndpoint } from '.';

import type { RouterConfig } from '@kc-console/shared-ui';

const useBreadcrumbItemsWithRegion = (routerConfig: RouterConfig) => {
  const { currentRegion } = useRegionEndpoint();
  const { items } = useBreadcrumbItems({ routerConfig });
  const breadcrumbs = useMemo(() => {
    const itemsWithRegion = items.map(item => ({
      ...item,
      href: item.href ? `${item.href}?region=${currentRegion}` : undefined,
    }));
    return [
      { label: 'Status Board', href: `${ROUTE_PATH.SERVICE_LIST}?region=${currentRegion}` },
      ...itemsWithRegion,
    ];
  }, [currentRegion, items]);

  return breadcrumbs;
};

export default useBreadcrumbItemsWithRegion;
